import React, { Component, Fragment, useLayoutEffect, useState } from "react";
import WindowsList from "./WindowsList";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';

class WindowContent extends Component {
    state = {
        show: true
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ canBeRefreshed: true })
        }, 500);
    }

    componentDidUpdate(prevProps) {
        // console.log(this.props.user)
        if (prevProps.user?.loggedin != this.props.user?.loggedin) {

            let path = this.props.data?.path
            path = path[0]

            // console.log('pathhhhhhh', path)
            if (this.state.canBeRefreshed && path != 'authentication') {
                this.setState({ show: false }, () => {
                    this.setState({ show: true })
                })
            }
        }
    }

    changeWindowLink = (nPath) => {

       
        let path = this.props.data?.path
        path = [path[0]]


        if (nPath != null) {
            for (let i = 0; i < nPath.length; i++) {
                if (nPath[i] != path[path.length - 1]) {
                    path.push(nPath[i])
                }
            }
        }

        // console.log(path)
        // return
        this.props.changeWindow(path[0], { path: path })
    }


    render() {

        // console.log(this.props)

        let path = this.props.data?.path
        let rootUrl = "/" + path[0]
        let type = path[0]
        // console.log(path)
        // console.log(type)
        // console.log(WindowsList[this.props.type.toLowerCase()])


        if (type) {

            let baseUrl = [path[0]]

            if (!WindowsList[type.toLowerCase()]) {


                if (path[1]) {
                    type = 'applet'
                    baseUrl = [path[0], path[1]]
                } else {
                    type = 'hub'
                }
            }

            // console.log('windowcontent2', type)



            let Component = WindowsList[type.toLowerCase()]



            if (Component && this.state.show) {
                // takeScreenshot
                // console.log(Component);
                return (
                    <div className="w-100 h-100 window-content-radius">
                        <Component windowId={this.props.windowId} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} baseUrl={baseUrl} mainColor={this.props.mainColor} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} isPortal={true} type={this.props.type} data={this.props.data} windowData={this.props.data} closeWindow={this.props.closeWindow} route={rootUrl} changeWindow={this.props.changeWindow} changeWindowLink={this.changeWindowLink} setWindowInfo={this.props.setWindowInfo} setWindowButtons={this.props.setWindowButtons} language={this.props.language} addNewWindow={this.props.addNewWindow} />
                    </div>
                )
            } else {
                return (
                    <div className="text-center pt-5 w-100 h-100 bg-white "  >
                        404 - Page Type Not Found
                    </div>
                )
            }
        } else {
            return <div></div>
        }
    }
}

// export default WindowContent;

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(WindowContent);
